import FormData from 'form-data';
import qs from 'qs';
import axios from 'axios';
import PawModel from './PawModel';
import { getClient } from '../utils/faye'

class Doc extends PawModel {
  static apiType = 'docs';

  title?: string;

  preview_url?: string;

  thumb_url?: string;

  file_url?: string;

  content_type?: string;

  static subscription?: any;

  static filters: {
    id?: string;
    created_at?: string;
    updated_at?: string;
    title?: undefined | string;
    weight?: undefined | string;
  } = {
    id: '',
    created_at: '',
    updated_at: '',
    title: '',
    weight: ''
  }

  static async create(payload: any) {
      let url = `/api/d2/${this.apiType}`;
      let body: any = { data: { attributes: payload } };
      const config: any = {};

      if (payload.file) {
        const formData = new FormData();
        formData.append('file', payload.file);
        const { file, title, ...attributes } = payload;
        const name = title || file.name;
        url = `/api/d2/${this.apiType}?${qs.stringify({ name, data: { attributes } }, { arrayFormat: 'brackets' })}`;
        body = formData;
      }

      const {
        data: { data },
      } = await axios.post(url, body, config);
      this.clearCache();
      this.store.dispatch({ type: 'UPSERT', payload: data });
      return new this(data);
  }

  static async sync() {
    const constructor = this;
    this.subscription = this.subscription || getClient().subscribe('/users/all', function(message: any) {
      if (message.action === "refresh_all_doc_thumb" && message.did) {
        const doc = constructor.get(message.did, false);
        if (doc) {
          constructor.get(message.did, true);
        }
      }
    });

    return this.subscription;
  }

  static async unsync() {
    if (!this.subscription) {
      return;
    }

    this.subscription.cancel();
  }

  // get href() {
  //   const name =
  //     new RegExp(this.mimetype).test(mime.contentType(this.name)) || !mime.extension(this.mimetype)
  //       ? this.name
  //       : `${this.name}.${mime.extension(this.mimetype)}`;
  //   return encodeURI(`${this.url}/${name}`);
  // }

  download() {
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);
    a.href = encodeURI(`/documents/${this.id}/upload?mode=attachment`);
    console.log(a.href);
    a.setAttribute("download", this.title);
    a.click();
    document.body.removeChild(a);
  }
}

export default Doc;
